module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "chapter-h"
  }, [_c('span', [_c('i', [_vm._v("Note on Intervolumens")])])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_vm._v("The three books of the trilogy make up, in the original format, "), _c('i', [_vm._v("one")]), _vm._v(" long book, composed of scrolls – here represented as Volumes. The "), _c('i', [_vm._v("Intervolumens")]), _vm._v(" are interpolated adventures and developments from other richer sources – since, in the scrolls of Lionwolf, many of these events are detailed sketchily, and in a sort of shorthand.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4976d0b1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/frantmatter03.vue
// module id = 78
// module chunks = 0